import {
  END_STUDENT_COURSE,
  START_STUDENT_COURSE,
  FETCH_STUDENT_COURSE,
  FETCH_STUDENT_COURSES,
  FETCH_REMAIN_STUDENT_COURSES_TO_CREATE_EXAM_REPORT
} from '../constants/student-course';

export function fetchStudentCourse(studentCourseId) {
  return ({
    type: FETCH_STUDENT_COURSE,
    api: true,
    auth: true,
    payload: {
      method: 'GET',
      url: `/students/student-courses/${studentCourseId}`
    }
  });
}

export function startStudentCourse(studentCourseId) {
  return ({
    type: START_STUDENT_COURSE,
    api: true,
    auth: true,
    payload: {
      method: 'PATCH',
      url: `/students/student-courses/${studentCourseId}/start`
    },
    data: {studentCourseId}
  });
}

export function endStudentCourse(studentCourseId) {
  return ({
    type: END_STUDENT_COURSE,
    api: true,
    auth: true,
    payload: {
      method: 'PATCH',
      url: `/students/student-courses/${studentCourseId}/end`
    },
    data: {studentCourseId}
  });
}

export function fetchStudentCourses() {
  return ({
    type: FETCH_STUDENT_COURSES,
    api: true,
    auth: true,
    payload: {
      method: 'GET',
      url: '/students/student-courses'
    }
  });
}

export function fetchRemainStudentCoursesToCreateExamReport() {
  return ({
    type: FETCH_REMAIN_STUDENT_COURSES_TO_CREATE_EXAM_REPORT,
    api: true,
    auth: true,
    payload: {
      method: 'GET',
      url: '/students/student-courses/remain'
    }
  });
}
